// extracted by mini-css-extract-plugin
module.exports = {"gameAreaMask":"GameAreaMask_gameAreaMask__1wVZM","maskText":"GameAreaMask_maskText__1qHVp"};